// src/components/relatorios/TabelaTopOS.js
import React from 'react';

function TabelaTopOS({ data }) {
  if (!data || data.length === 0) {
    return <p style={{ textAlign: 'center', color: '#999', padding: '20px' }}>Nenhum dado disponível</p>;
  }

  const n = (v) => {
    const x = Number(v);
    return Number.isFinite(x) ? x : 0;
  };

  const formatCurrency = (valor) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(n(valor));
  };

  return (
    <div style={{ overflowX: 'auto' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ background: '#f3f4f6', borderBottom: '2px solid #e5e7eb' }}>
            <th style={{ padding: '12px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: '#6b7280' }}>#</th>
            <th style={{ padding: '12px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: '#6b7280' }}>OS / CLIENTE</th>
            <th style={{ padding: '12px', textAlign: 'right', fontSize: '12px', fontWeight: '600', color: '#6b7280' }}>VALOR</th>
            <th style={{ padding: '12px', textAlign: 'right', fontSize: '12px', fontWeight: '600', color: '#6b7280' }}>CUSTO</th>
            <th style={{ padding: '12px', textAlign: 'right', fontSize: '12px', fontWeight: '600', color: '#6b7280' }}>LUCRO</th>
            <th style={{ padding: '12px', textAlign: 'center', fontSize: '12px', fontWeight: '600', color: '#6b7280' }}>MARGEM</th>
          </tr>
        </thead>
        <tbody>
          {data.map((os, index) => {
            const margem = n(os.margem_percentual);

            return (
              <tr key={os.id} style={{ borderBottom: '1px solid #e5e7eb' }}>
                <td style={{ padding: '12px', fontSize: '14px', fontWeight: 'bold', color: '#374151' }}>
                  {index + 1}º
                </td>
                <td style={{ padding: '12px' }}>
                  <div style={{ fontSize: '14px', fontWeight: '600', color: '#111827', marginBottom: '4px' }}>
                    OS #{os.id} - {os.titulo}
                  </div>
                  <div style={{ fontSize: '12px', color: '#6b7280' }}>
                    {os.cliente || 'Cliente não informado'}
                  </div>
                </td>
                <td style={{ padding: '12px', textAlign: 'right', fontSize: '14px', color: '#111827' }}>
                  {formatCurrency(os.valor_total)}
                </td>
                <td style={{ padding: '12px', textAlign: 'right', fontSize: '14px', color: '#ef4444' }}>
                  {formatCurrency(os.custo_total)}
                </td>
                <td style={{ padding: '12px', textAlign: 'right', fontSize: '15px', fontWeight: 'bold', color: '#10b981' }}>
                  {formatCurrency(os.lucro)}
                </td>
                <td style={{ padding: '12px', textAlign: 'center' }}>
                  <span style={{
                    padding: '4px 12px',
                    borderRadius: '12px',
                    fontSize: '13px',
                    fontWeight: '600',
                    background: margem >= 20 ? '#d1fae5' : margem >= 10 ? '#fef3c7' : '#fee2e2',
                    color: margem >= 20 ? '#065f46' : margem >= 10 ? '#92400e' : '#991b1b'
                  }}>
                    {margem.toFixed(1)}%
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default TabelaTopOS;
